module.exports = __webpack_public_path__ + "static/media/fechaEmision.7c258462.png";